/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseCcsReport } from '../models/ApiResponseCcsReport';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CcsReportControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseCcsReport OK
   * @throws ApiError
   */
  public getAdasReport({
    vin,
    month = '202510',
  }: {
    vin: string,
    month?: string,
  }): CancelablePromise<ApiResponseCcsReport> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/report/adas',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
  /**
   * @returns ApiResponseCcsReport OK
   * @throws ApiError
   */
  public getAdasReport1({
    vin,
    month = '202510',
  }: {
    vin: string,
    month?: string,
  }): CancelablePromise<ApiResponseCcsReport> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/report/adas/',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
  /**
   * @returns ApiResponseCcsReport OK
   * @throws ApiError
   */
  public getCcsReport({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseCcsReport> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/ccs-report/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * @returns ApiResponseCcsReport OK
   * @throws ApiError
   */
  public getCcsReport1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseCcsReport> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/ccs-report',
      path: {
        'vin': vin,
      },
    });
  }
}
